import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
export function createAppStore() {
    const store = createStore()(() => ({
        bootPhase: 'starting',
        workerError: null,
        hydrationError: null,
        viewerMode: null,
    }));
    const actions = {
        setBootPhase(phase) {
            store.setState({ bootPhase: phase });
        },
        setWorkerError(err) {
            store.setState({ workerError: err });
        },
        setHydrationError(err) {
            store.setState({ hydrationError: err });
        },
        setViewerMode(mode) {
            store.setState({ viewerMode: mode });
        },
        getPublicSnapshot() {
            return { viewerMode: store.getState().viewerMode };
        },
    };
    return { store, actions };
}
export function useAppStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=app-store.js.map